import { motion } from "framer-motion"
import PropTypes from "prop-types"
import styled from "styled-components"

const StyledFeedback = styled(motion.div)`
  padding: ${({ padding, theme }) => padding || `${theme.sizes.gapSmall - 2}px ${theme.sizes.gapSmall}px`};
  margin: ${({ margin }) => margin || "0"};

  font-family: ${({ theme }) => theme.fontFamily.geberitRg};
  font-size: 14px;
  line-height: 20px;

  &.warning {
    background-color: ${({ theme }) => theme.colors.warningTransparency10};
  }

  &.info {
    background-color: ${({ theme }) => theme.colors.brand[50]};
  }
`

const Feedback = ({ type, children, margin, padding }) => {
  return (
    <StyledFeedback
      className={type}
      margin={margin}
      padding={padding}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {children}
    </StyledFeedback>
  )
}

export default Feedback

Feedback.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  type: PropTypes.oneOf(["warning", "success", "error", "info"]),
  margin: PropTypes.string,
  padding: PropTypes.string,
}
